// Shared color palette for Analytics charts, matching the status-color conventions already
// used elsewhere in the app (src/app/analytics/index.js hold/completed/processing/cancelled).
export const CHART_COLORS = [
  "#2271b1",
  "#5b841b",
  "#94660c",
  "#c0392b",
  "#8e44ad",
  "#16a085",
  "#e67e22",
  "#34495e",
];

export const STATUS_COLORS = {
  completed: "#5b841b",
  processing: "#2e4453",
  pending: "#94660c",
  "on-hold": "#94660c",
  cancelled: "#777777",
  refunded: "#8e44ad",
  failed: "#c0392b",
};
